import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Switch } from 'react-router-dom';
import Post from './Post';

const Profil = () =>{
    const [posts, setPosts] = useState([]);
    const [firstNews, setFirstNews] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      const response = await fetch('/posts/posts.json');
      const postList = await response.json();
      /*const postList = [
        { id: 'post1', title: 'My First Blog Post' },
        { id: 'post2', title: 'My Second Blog Post' },
        { id: 'post3', title: 'My Third Blog Post' }
      ];*/
      setPosts(postList);
    };

    fetchPosts();

    
  }, []);

  useEffect(() => {
    const fetchNews = async () => {
      const response = await fetch('/posts/berita/posts.json');
      const newsList = await response.json();
      
      if (newsList.length > 0) {
        setFirstNews(newsList[0]);
      }
    };
    fetchNews();
  }, []);
    return(
        <div>
            <div class="ttm-page-title-row">
            <div class="ttm-page-title-row-inner  ttm-bgcolor-darkgrey">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-12" style={{textAlign:'left'}}>
                            <div class="page-title-heading">
                                <h2 class="title">PPID Biro Perencanaan, Keuangan, dan Umum</h2>
                            </div>
                            <div class="breadcrumb-wrapper">
                                <span><a class="pathway" href="/">Home</a></span><span><a class="pathway" href="/profil"> Profil</a></span>                              
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="site-main">
           
            <div class="ttm-row sidebar ttm-sidebar-right ttm-bgcolor-white clearfix">
                <div class="container">
                   
                    <div class="row">
                        <div class="col-xl-9 col-lg-8 content-area" style={{textAlign:'left'}}>
                          <article class="post ttm-blog-single clearfix">
   
    <div class="ttm-blog-single-content">
        <div class="ttm-post-entry-header">
            <div class="post-meta">
                <span class="ttm-meta-line tags-links">
                    Diperbaharui pada : 21 Agustus 2025</span>
            </div>
        </div>
        <div class="entry-content mt-10">
            <div class="ttm-box-desc-text">
                <h4>Informasi Wajib Diumumkan Secara Berkala</h4>
                <p>Informasi yang wajib disediakan dan diumumkan secara berkala adalah informasi yang wajib diperbaharui kemudian disediakan dan diumumkan kepada publik secara rutin atau berkala sekurang-kurangnya setiap 6 bulan sekali berdasarkan Peraturan Komisi Informasi No. 1 Tahun 2021 Pasal 14</p>
                
                <h4>Informasi Tersedia Setiap Saat</h4>
                <p>Informasi Tersedia Setiap Saat adalah Informasi Publik yang harus disediakan oleh Badan Publik dan siap tersedia apabila ada permohonan terhadap informasi Publik tersebut, hal tersebut di atur dalam Peraturan Komisi Informasi No 1 Tahun 2021 pasal 21</p>
                
                <h4>Daftar Informasi Publik</h4>
                <p>Informasi Publik harus disediakan oleh Badan Publik dan siap tersedia jika ada permohonan terhadap informasi Publik tersebut. Hal ini telah diatur dalam Peraturan Komisi Informasi No 1 Tahun 2021 pasal 21 tentang Informasi Wajib Tersedia Setiap Saat</p>
                
            </div>
        </div>
    </div>
   
</article>                          
                        </div>
                        <div class="col-xl-3 col-lg-4 widget-area sidebar-right ttm-col-bgcolor-yes ttm-bg ttm-right-span ttm-bgcolor-grey mt_60 pt-60 mb_60 pb-60 res-991-mt-0 res-991-pt-0">
                            <div class="ttm-col-wrapper-bg-layer ttm-bg-layer"></div>

<aside class="widget widget-recent-post with-title" style={{textAlign:'left'}}>
    <h3 class="widget-title">Berita</h3>
    <ul class="widget-post ttm-recent-post-list">
                        <li>
                    <span class="post-date">{firstNews?.date}</span>
                    <Link to={`/post/berita/${firstNews?.id}`}> {firstNews?.title}</Link>
                </li>
            </ul>
</aside>
              </div>
                    </div>
                 
                </div>
            </div>
           

        </div>
        </div>
    );
};

export default Profil;